module.exports = __webpack_public_path__ + "img/handraw_fraicheur - footer.b8c9e0da.svg";